import React from "react";
import "./Repository.css";

export default function Repository() {
  return (
    <div className="animate__animated animate__slideInUp">
      <div className="repository">
        <a
          href="https://github.com/Valmarinoa"
          target="_blank"
          rel="noreferrer"
        >
          <strong>Open-source code</strong>
        </a>{" "}
        by Valmarinoa
      </div>
    </div>
  );
}
